import { KeyboardArrowDown } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import {
  Card,
  Grid,
  InputAdornment,
  InputBase,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { H5, Small } from 'components/Typography';
import { customShadows } from 'theme/shadows';

export default function SearchCard({ filters, setFilter, columns, data }) {
  // Get unique values for select dropdowns
  const getSelectOptions = accessor => {
    const options = new Set();
    data.forEach(row => {
      if (row[accessor]) {
        options.add(row[accessor]);
      }
    });
    return [...options];
  };

  const getFilterValue = accessor => {
    const filter = filters.find(f => f.id === accessor);
    return filter ? filter.value : '';
  };

  return (
    <Card
      sx={{
        padding: '20px 24px',
        borderRadius: '18px',
        boxShadow: customShadows.card,
        backgroundColor: '#ffffff',
        border: 'none',
        marginBottom: 3,
      }}
    >
      <H5
        sx={{
          color: theme => theme.palette.primary.dark,
          fontWeight: 500,
          marginBottom: '16px',
        }}
      >
        유저 관리
      </H5>

      <Grid container spacing={1.5}>
        {/* 이름 검색 */}
        <Grid item xs={12} sm={4} md={2}>
          <Small
            sx={{
              color: theme => theme.palette.primary.dark,
              fontWeight: 400,
              marginBottom: '6px',
              display: 'block',
            }}
          >
            이름 (총 유저 1,466명)
          </Small>
          <TextField
            fullWidth
            placeholder="이름..."
            value={getFilterValue('name')}
            onChange={e => setFilter('name', e.target.value || undefined)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon sx={{ color: '#4285F4', fontSize: 18 }} />
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                height: 36,
                fontSize: 13,
                borderRadius: '50px',
                backgroundColor: '#F8F8F8',
                border: '0px solid #ECEEF4',
                '&:hover': {
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ECEEF4',
                  },
                },
                '&.Mui-focused': {
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ECEEF4',
                    borderWidth: 1,
                  },
                },
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ECEEF4',
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 16px',
              },
            }}
          />
        </Grid>

        {/* 닉네임 검색 */}
        <Grid item xs={12} sm={4} md={2}>
          <Small
            sx={{
              color: theme => theme.palette.primary.dark,
              fontWeight: 400,
              marginBottom: '6px',
              display: 'block',
            }}
          >
            닉네임
          </Small>
          <TextField
            fullWidth
            placeholder="닉네임..."
            value={getFilterValue('nickname')}
            onChange={e => setFilter('nickname', e.target.value || undefined)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon sx={{ color: '#4285F4', fontSize: 18 }} />
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                height: 36,
                fontSize: 13,
                borderRadius: '50px',
                backgroundColor: '#F8F8F8',
                border: '0px solid #ECEEF4',
                '&:hover': {
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ECEEF4',
                  },
                },
                '&.Mui-focused': {
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ECEEF4',
                    borderWidth: 1,
                  },
                },
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ECEEF4',
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 16px',
              },
            }}
          />
        </Grid>

        {/* 이메일 검색 */}
        <Grid item xs={12} sm={4} md={2}>
          <Small
            sx={{
              color: theme => theme.palette.primary.dark,
              fontWeight: 400,
              marginBottom: '6px',
              display: 'block',
            }}
          >
            이메일
          </Small>
          <TextField
            fullWidth
            placeholder="이메일..."
            value={getFilterValue('email')}
            onChange={e => setFilter('email', e.target.value || undefined)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon sx={{ color: '#4285F4', fontSize: 18 }} />
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                height: 36,
                fontSize: 13,
                borderRadius: '50px',
                backgroundColor: '#F8F8F8',
                border: '0px solid #ECEEF4',
                '&:hover': {
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ECEEF4',
                  },
                },
                '&.Mui-focused': {
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ECEEF4',
                    borderWidth: 1,
                  },
                },
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ECEEF4',
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 16px',
              },
            }}
          />
        </Grid>

        {/* 전화번호 검색 */}
        <Grid item xs={12} sm={4} md={2}>
          <Small
            sx={{
              color: theme => theme.palette.primary.dark,
              fontWeight: 400,
              marginBottom: '6px',
              display: 'block',
            }}
          >
            전화번호
          </Small>
          <TextField
            fullWidth
            placeholder="전화번호..."
            value={getFilterValue('phone')}
            onChange={e => setFilter('phone', e.target.value || undefined)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon sx={{ color: '#4285F4', fontSize: 18 }} />
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                height: 36,
                fontSize: 13,
                borderRadius: '50px',
                backgroundColor: '#F8F8F8',
                border: '0px solid #ECEEF4',
                '&:hover': {
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ECEEF4',
                  },
                },
                '&.Mui-focused': {
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ECEEF4',
                    borderWidth: 1,
                  },
                },
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ECEEF4',
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 16px',
              },
            }}
          />
        </Grid>

        {/* 고객 분류 선택 */}
        <Grid item xs={12} sm={4} md={2}>
          <Small
            sx={{
              color: theme => theme.palette.primary.dark,
              fontWeight: 400,
              marginBottom: '6px',
              display: 'block',
            }}
          >
            고객 분류
          </Small>
          <Select
            fullWidth
            value={getFilterValue('customerType')}
            onChange={e =>
              setFilter('customerType', e.target.value || undefined)
            }
            displayEmpty
            IconComponent={() => (
              <KeyboardArrowDown
                sx={{ color: '#B5B7C0', marginRight: 1, fontSize: 20 }}
              />
            )}
            input={
              <InputBase
                sx={{
                  height: 36,
                  fontSize: 13,
                  borderRadius: '50px',
                  color: 'text.primary',
                  backgroundColor: '#F8F8F8',
                  paddingLeft: 2,
                  paddingRight: 0.5,
                  border: '0px solid #ECEEF4',
                  '&:hover': {
                    borderColor: '#ECEEF4',
                  },
                  '&.Mui-focused': {
                    borderColor: '#ECEEF4',
                  },
                }}
              />
            }
          >
            <MenuItem value="" sx={{ fontSize: 13 }}>
              전체
            </MenuItem>
            <MenuItem value="일반" sx={{ fontSize: 13 }}>
              일반
            </MenuItem>
            <MenuItem value="VIP" sx={{ fontSize: 13 }}>
              VIP
            </MenuItem>
            <MenuItem value="기업" sx={{ fontSize: 13 }}>
              기업
            </MenuItem>
          </Select>
        </Grid>

        {/* 계정 활성 선택 */}
        <Grid item xs={12} sm={4} md={2}>
          <Small
            sx={{
              color: theme => theme.palette.primary.dark,
              fontWeight: 400,
              marginBottom: '6px',
              display: 'block',
            }}
          >
            계정 활성
          </Small>
          <Select
            fullWidth
            value={getFilterValue('accountActive')}
            onChange={e =>
              setFilter('accountActive', e.target.value || undefined)
            }
            displayEmpty
            IconComponent={() => (
              <KeyboardArrowDown
                sx={{ color: '#B5B7C0', marginRight: 1, fontSize: 20 }}
              />
            )}
            input={
              <InputBase
                sx={{
                  height: 36,
                  fontSize: 13,
                  borderRadius: '50px',
                  color: 'text.primary',
                  backgroundColor: '#F8F8F8',
                  paddingLeft: 2,
                  paddingRight: 0.5,
                  border: '0px solid #ECEEF4',
                  '&:hover': {
                    borderColor: '#ECEEF4',
                  },
                  '&.Mui-focused': {
                    borderColor: '#ECEEF4',
                  },
                }}
              />
            }
          >
            <MenuItem value="" sx={{ fontSize: 13 }}>
              전체
            </MenuItem>
            <MenuItem value="활성" sx={{ fontSize: 13 }}>
              활성
            </MenuItem>
            <MenuItem value="비활성" sx={{ fontSize: 13 }}>
              비활성
            </MenuItem>
          </Select>
        </Grid>
      </Grid>
    </Card>
  );
}
